import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Root = styled.div`
  display: inline-flex;
  column-gap: 4px;
`;

const Key = styled.div`
  display: inline-flex;
  font-weight: 700;
  text-transform: capitalize;
`;

import { brands } from "../../config/brands";

export const ActiveFilters = ({ activeFilters }) => {
  const keys = Object.keys(activeFilters).filter(
    (key) =>
      !(
        key === "data" &&
        (!activeFilters[key] || !activeFilters[key].distributor)
      )
  );
  return (
    <Root>
      {keys.map((key, idx) => {
        let filterValues;

        if (Array.isArray(activeFilters[key])) {
          switch (key) {
            case "brands":
              filterValues = activeFilters[key]
                .map(
                  (item) =>
                    brands.find((brand) => brand.id === item)?.label ||
                    "Unknown"
                )
                .join(", ");
              break;
            case "points":
              console.info(activeFilters[key]);
              if (activeFilters[key][0] === activeFilters[key][1]) {
                filterValues = `${activeFilters[key][0]}`;
              } else if (
                activeFilters[key][0] == null ||
                activeFilters[key][0] === ""
              ) {
                filterValues = `less than ${activeFilters[key][1]}`;
              } else if (
                activeFilters[key][1] == null ||
                activeFilters[key][1] === ""
              ) {
                filterValues = `greater than ${activeFilters[key][0]}`;
              } else {
                filterValues = `from ${activeFilters[key][0]} to ${activeFilters[key][1]}`;
              }

              break;
            default:
              filterValues = activeFilters[key].join(", ");
          }
        } else if (
          key === "data" &&
          activeFilters[key] &&
          typeof activeFilters[key] === "object" &&
          activeFilters[key].distributor
        ) {
          const dist = activeFilters[key].distributor;
          filterValues =
            typeof dist === "object" && dist?.$regex != null ? dist.$regex : dist;
        } else if (
          activeFilters[key] &&
          typeof activeFilters[key] === "object" &&
          "$regex" in activeFilters[key]
        ) {
          filterValues = activeFilters[key].$regex;
        } else if (activeFilters[key] && typeof activeFilters[key] === "object" && "start" in activeFilters[key] && "end" in activeFilters[key]) {
          const dr = activeFilters[key];
          filterValues = dr.start && dr.end
            ? `${new Date(dr.start).toLocaleDateString()} – ${new Date(dr.end).toLocaleDateString()}`
            : "";
        } else {
          filterValues = activeFilters[key];
        }

        if (typeof filterValues === "object" && filterValues !== null) {
          filterValues = String(filterValues);
        }

        const displayKey =
          key === "data.distributor" || key === "data" ? "Distributor" : key;

        return (
          <span key={key}>
            <Key>{displayKey}</Key>: {filterValues}
            {idx !== keys.length - 1 && ", "}
          </span>
        );
      })}
    </Root>
  );
};

ActiveFilters.propTypes = {
  activeFilters: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      ),
      PropTypes.string,
      PropTypes.number,
      // distributor: { $regex: string, $options?: string }
      PropTypes.shape({
        $regex: PropTypes.string,
        $options: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
      // dateRange: { start: number, end: number }
      PropTypes.shape({
        start: PropTypes.number,
        end: PropTypes.number,
      }),
    ])
  ),
};
